import { DeleteConsignmentEvent, NewConsignmentEvent, EditConsignmentEvent, ActivateEmailPodEvent } from './shared/event.service';
import {
  BrowserAnimationsModule
} from '@angular/platform-browser/animations';
import {
  NgModule,
  ModuleWithProviders
} from '@angular/core';
import {
  CommonModule
} from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  HttpClientModule
} from '@angular/common/http';
import {
  VehicleTypeService,
  BranchService,
  PostcodeService,
  FailureReasonService,
  SurchargeService,
  SurchargeTypeService,
  ExceptionCodeService,
  UserService,
  RoleService,
  MenuService,
  SubcontractorService,
  AddressBookService,
  TariffService,
  SupplierService,
  CustomerService,
  QuotationsService,
  HxNotificationsService,
  RateServiceService,
  ConsignmentService,
  GoogleMapService,
  PacketSurchargeService,
  PacketRateService,
  BoxRateService,
  PalletRateService,
  PalletSurchargeService,
  SameDayRateService,
  ConsignmentNoteService,
  SubcontractorNoteService,
  CountryService,
  ZoneService,
  InternationalSupplierService,
  AdditionalDropsService,
  BaseRateService,
  RoadRateService,
  PrintService,
  CustomerInvoiceService,
  InternationalSurchargeService,
  NewSupplierInvoiceService,
  SupplierInvoiceSearchService,
  AuthoriseSupplierInvoiceService,
  PrintCustomerStatementService,
  LoginService,
  PODAdditionalDropService,
  ConsignmentActionsService,
  LabelService,
  SignalRService,
  StandingOrderService,
} from './http';
import {
  API_URL
} from '../@core/http/config/api';
import {
  IntercepterService
} from '../@core/http/config/http.interceptor';
import {
  environment
} from '../environments/environment';
import {
  BoSpinnerService,
  BoToastrService
} from './shared';
import { ConsignmentPodService } from '../app/consignments/consignment-dashboard/actions-modal/consignment-pod/consignment-pod.service';
import { ConsignmentLogService } from '../app/consignments/consignment-dashboard/actions-modal/consignment-log/consignment-log.service';
@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    BrowserAnimationsModule
  ],
  declarations: []
})
export class CoreModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: CoreModule,
      providers: [{
        provide: API_URL,
        useValue: environment.baseUrl
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: IntercepterService,
        multi: true
      },
        VehicleTypeService,
        BranchService,
        PostcodeService,
        FailureReasonService,
        SurchargeService,
        SurchargeTypeService,
        ExceptionCodeService,
        UserService,
        RoleService,
        MenuService,
        SubcontractorService,
        SubcontractorNoteService,
        AddressBookService,
        TariffService,
        SupplierService,
        CustomerService,
        ConsignmentService,
        QuotationsService,
        HxNotificationsService,
        GoogleMapService,
        ConsignmentNoteService,
        RateServiceService,
        PacketSurchargeService,
        PacketRateService,
        BoxRateService,
        PalletRateService,
        PalletSurchargeService,
        SameDayRateService,
        CountryService,
        ZoneService,
        InternationalSupplierService,
        BoSpinnerService,
        BoToastrService,
        AdditionalDropsService,
        SupplierInvoiceSearchService,
        BaseRateService,
        RoadRateService,
        PrintService,
        CustomerInvoiceService,
        InternationalSurchargeService,
        NewSupplierInvoiceService,
        AuthoriseSupplierInvoiceService,
        PrintCustomerStatementService,
        LoginService,
        PODAdditionalDropService,
        DeleteConsignmentEvent,
        ActivateEmailPodEvent,
        NewConsignmentEvent,
        EditConsignmentEvent,
        ConsignmentPodService,
        ConsignmentActionsService,
        ConsignmentLogService,
        LabelService,
        SignalRService,
        StandingOrderService,
      ]
    };
  }
}
